const routes = [
  {
    path: '/record-form-course/:courseId',
    name: 'UserRecordCourse',
    component: () => import(/* webpackChunkName: "authorize" */ './pages/UserRecordCourse.vue'),
    meta: {
      title: 'Форма зачисления',
      authorize: [],
    },
  },
  {
    path: '/settings',
    name: 'UserSettings',
    component: () => import('./pages/UserSettings.vue'),
    meta: {
      title: 'Настройки пользователя',
      authorize: [],
    },
  },
  {
    path: '/widgets',
    name: 'UserWidget',
    component: () => import('./pages/UserWidgets.vue'),
    meta: {
      title: 'Виджеты пользователя',
      authorize: [],
    },
  },
];

export default routes;
